import React from "react";
// material
import {
  Box,
  Card,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableFooter,
  TablePagination,
} from "@mui/material";
import TableHead from "./tableHead";
import NotData from "src/pages/noData";

// ----------------------------------------------------------------------

export default function CustomTable({ ...props }) {
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(20);
  function handleChangePage(event, newpage) {
    setpg(parseFloat(newpage));
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value));
    setpg(0);
  }
  const {
    type,
    headData,
    data,
    isLoading,
    mobileRow,
    row,
    rows,
    hiddenPagination,
    getBoolValues,
    ...rest
  } = props;
  const Component = row;
  const CardComponent = mobileRow;
  const { outerIndex, values } = rest;
  if (values?.assigned_docs?.[outerIndex]) {
    const sourceData = data?.data || data || [];
    if (values.assigned_docs[outerIndex].docs?.length > 0) {
      let doc = values.assigned_docs[outerIndex].docs;
      let newData = sourceData.map((item, index) =>
        doc.find((docItem) => docItem._id == item._id) == undefined
          ? item
          : doc[index]
      );
      console.log(newData, "newData");
      values.assigned_docs[outerIndex].docs = newData;
    } else {
      values.assigned_docs[outerIndex].docs = sourceData;
    }
  }
  const rawTableData =
    values?.assigned_docs?.[outerIndex]?.docs || data?.data || data || [];
  const tableData = Array.isArray(rawTableData) ? rawTableData : [];
  const pagedData = tableData.slice(pg * rpg, pg * rpg + rpg);
  const hasMobileCards = Boolean(CardComponent);

  return (
    <>
      {!isLoading && tableData.length === 0 ? (
        <NotData />
      ) : (
        <>
          <Card
            sx={{
              display: hasMobileCards ? { xs: "none", md: "block" } : "block",
              overflow: "hidden",
            }}
          >
            <TableContainer sx={{ width: 1, overflowX: "auto" }}>
              <Table sx={{ minWidth: { xs: 680, md: 800 } }}>
                <TableHead headData={headData} />
                <TableBody>
                  {(isLoading
                    ? Array.from(new Array(rows || 6))
                    : pagedData
                  )?.map((item, index) => {
                    const stableKey =
                      item?._id ??
                      item?.id ??
                      item?.key ??
                      item?.uuid ??
                      item?.slug ??
                      index;
                    return (
                      <Component
                        key={stableKey}
                        row={item}
                        index={index}
                        data={data}
                        serialNumber={
                          pg == 0 ? index + 1 : pg * rpg + index + 1
                        }
                        isLoading={isLoading}
                        {...rest}
                      />
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 20, 25]}
                      count={tableData.length}
                      rowsPerPage={rpg}
                      page={pg}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Card>

          {hasMobileCards && (
            <Box
              sx={{
                display: { xs: "grid", md: "none" },
                gap: 1.5,
              }}
            >
              {(isLoading ? Array.from(new Array(rows || 6)) : pagedData).map(
                (item, index) => (
                <CardComponent
                  key={
                    item?._id ??
                    item?.id ??
                    item?.key ??
                    item?.uuid ??
                    item?.slug ??
                    index
                  }
                  item={item}
                  row={item}
                  isLoading={isLoading}
                  serialNumber={pg == 0 ? index + 1 : pg * rpg + index + 1}
                  {...rest}
                />
                )
              )}
              <Card sx={{ overflow: "hidden" }}>
                <TablePagination
                  component="div"
                  rowsPerPageOptions={[5, 10, 20, 25]}
                  count={tableData.length}
                  rowsPerPage={rpg}
                  page={pg}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Card>
            </Box>
          )}
          {/* {!isLoading && !hiddenPagination && (
            <Stack alignItems="flex-end" mt={2} pr={2}>
              <Pagination data={data} />
            </Stack>
          )} */}
        </>
      )}
    </>
  );
}
